// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import {buildDate} from '../../../shared/services/build-date';

/* eslint-disable react/prefer-stateless-function */

class DateCellRenderer extends Component {

    render() {

        return (
            <div className='date-cell-renderer'>
                {buildDate(this.props.value)}
            </div>
        );

    }
}

DateCellRenderer.displayName = 'DateCellRenderer';
DateCellRenderer.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};
export default DateCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/date-cell-renderer.js